module.exports = __webpack_public_path__ + "static/media/interactive_map.4b738cf0.svg";